<div class="enquiries_sec">
    <section class="table_section">
        <div class="custom-sticky-table" fxLayout="column" fxLayoutAlign="start stretch">
            <button type="button" mat-button class="table_fixed_add" (click)="addEmployeeType()">
                <i class="material-icons">add_circle_outline</i> Add Employee Type
            </button>
            <perfect-scrollbar>
                <table mat-table [dataSource]="employeeType" matSort class="mat-elevation-z8">

                    <ng-container matColumnDef="sNo">
                        <th mat-header-cell *matHeaderCellDef> S.No </th>
                        <td mat-cell *matCellDef="let element; let i = index"> {{ i + 1 }} </td>
                    </ng-container>

                    <ng-container matColumnDef="employee_type_name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> EmployeeType Name </th>
                        <td mat-cell *matCellDef="let element"> {{ element.employee_type_name }} </td>
                    </ng-container>

                    <ng-container matColumnDef="created_at">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Created At </th>
                        <td mat-cell *matCellDef="let element"> {{ element.created_at | date: 'dd-MM-yyyy hh:mm:ss' }} </td>
                    </ng-container>

                    <ng-container matColumnDef="updated_at">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Updated At </th>
                        <td mat-cell *matCellDef="let element"> {{ element.updated_at | date: 'dd-MM-yyyy hh:mm:ss' }} </td>
                    </ng-container>

                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef> Action </th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-icon-button [matMenuTriggerFor]="menu" *ngIf="element.employee_Type_name !== 'Role'">
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                                <button type="button" mat-menu-item [routerLink]="" (click)="editEmployeeType(element)">
                                    <mat-icon>edit</mat-icon> Edit
                                </button>
                                <button type="button" mat-menu-item [routerLink]="" (click)="deleteEmployeeType(element)">
                                    <mat-icon>delete</mat-icon> Delete
                                </button>

                            </mat-menu>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                </table>

            </perfect-scrollbar>
        </div>
    </section>
</div>